import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'

import { Stack } from '@mui/material'

import { useGetNetworkQuery } from '@/core/services/network'

import NotFoundPage from '@/pages/error/NotFoundPage'

import NetworkSettings from '../components/NetworkSettings'
import { useNetworkMemberPermissions } from '../hooks/useNetworkMemberPermissions'

export default function NetworkSettingsContainer() {
  const { networkId } = useParams<{ networkId: string }>()

  const { data: network } = useGetNetworkQuery(networkId ?? skipToken)
  const { isNetworkAdmin } = useNetworkMemberPermissions({ networkId })

  if (!network || !isNetworkAdmin) {
    return (
      <Stack alignItems="center" justifyContent="center" width="100%" height="100%">
        <NotFoundPage />
      </Stack>
    )
  }
  return <NetworkSettings network={network} />
}
